import React, { Component } from 'react';
import 'css/loading.less'

const phrases = [
{
  text: 'Thanks for being a part of edgebet - we really appreciate it!',
  small: '- Your friends at Edgebet'
},
{
  text: 'Sometimes you eat the bear and sometimes the bear, well, eats you.',
  small: '- Your friends at Edgebet'
},
{
  text: 'Perfect, you\'re here! The day just got better.',
  small: '- Your friends at Edgebet'
},
{
  text: 'You look very nice today!',
  small: '- Your friends at Edgebet'
},
{
  text: 'How many bets can I place today?',
  small: '- Your friends at Edgebet'
},
{
  text: 'Remember to check that your open bets gets closed!',
  small: '- Your friends at Edgebet'
},
{
  text: 'Did you know you can request features we should build? We want you to be happy!',
  small: '- Your friends at Edgebet'
},
{
  text: 'We hope you run really good today!',
  small: '- Your friends at Edgebet'
},
{
  text: 'What a day! What cannot be accomplished on such a splendid day?',
  small: '- Your friends at Edgebet'
},
{
  text: 'We\'re all in this together!',
  small: '- Your friends at Edgebet'
},
{
  text: 'Always get plenty of sleep, if you can.',
  small: '- Your friends at Edgebet'
},
{
  text: 'Are you ready for the European Championship? We are!',
  small: '- Your friends at Edgebet'
},
{
  text: 'This is gonna be the best Olympics ever. You can bet on it.',
  small: '- Your friends at Edgebet'
},
{
  text: 'Did you know you can choose bet sizing alternatives in your profile?',
  small: '- Your friends at Edgebet'
},
]

export default class LoadingComponent extends Component {
  componentWillMount() {
    this.phrase = phrases[Math.floor(Math.random() * phrases.length)]
  }
  render() {
    return (
      <div className='container-fluid loading-container'>
        <img className='img img-responsive center-block' src='/static/logo.png' />
        <div className='phrase'>
          <p>{ this.phrase.text }</p>
          <small>{ this.phrase.small }</small>
        </div>
        <div className="sk-folding-cube">
          <div className="sk-cube1 sk-cube" />
          <div className="sk-cube2 sk-cube" />
          <div className="sk-cube4 sk-cube" />
          <div className="sk-cube3 sk-cube" />
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/LoadingComponent.js
 **/